import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyHeading, MyGlobal, MyAlert } from '../components/GlobalContext';

export class ConfirmLocationChargeSkeleton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            loading: true,
            alertMessage: "",
            chargeTypes: [],
            selectedStatus: "",
            selectedStatusId: "",
            selectedChargeType: "",
            selectedChargeTypeId: "",
            previouslySelectedChargeTypeId: "",
            selectedLocationText: "",
            selectedLocationId: "",
            chargeUpdateCompleted: false
        };
        
    }

    componentDidMount() {
        this.bindLocationData();
        this.getLocationChargeTypes();
    }
    bindLocationData() {

        if (this.props.locationData != null) {
            if (this.props.locationData.length > 0) {
              
                for (var value of this.props.locationData) {
                    this.state.selectedStatus = value.Status;
                    this.state.selectedStatusId = value.StatusID;
                    this.state.selectedChargeType = value.Charge;
                    this.state.selectedChargeTypeId = value.ChargeID;
                    this.state.previouslySelectedChargeTypeId = value.ChargeID;
                    this.state.selectedLocationText = value.NAME + "-" + value.LOC_COLUMN + "-" + value.LOC_LEVEL + "-" + value.TRAY;
                    this.state.selectedLocationId = value.LOC_ID;
                }
            }
        }
    }

    getLocationChargeTypes() {

        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Location/GetLocationChargeTypesToBeConfirmed`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Charge Types!!", chargeUpdateCompleted: true });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ chargeTypes: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Charge Types!!  " + apiResponse.errorMessage, chargeUpdateCompleted: true });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Charge Types!!", chargeUpdateCompleted: true });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, chargeUpdateCompleted: true });
            });
    }

    validateLocationStatus() {
        this.setState({ loading: true, alertMessage: "" });
        this.updateLocationStatusCharge(); 
    }

    updateLocationStatusCharge() {

        this.setState({ loading: true, alertMessage: "" });

        if (this.state.selectedLocationId === 0) {
            this.setState({ loading: false, alertMessage: "Please scan the location", chargeUpdateCompleted: true });
            return;
        }
        if (parseInt(this.state.selectedChargeTypeId) === this.state.previouslySelectedChargeTypeId) {
            this.setState({ loading: false, alertMessage: "Location charge unchanged", chargeUpdateCompleted: true });
            return;
        }

        var updateLocationStatusChargeRequest = {
            locationId: this.state.selectedLocationId,
            locationStatusId: this.state.selectedStatusId,
            LocationChargeTypeId: this.state.selectedChargeTypeId
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateLocationStatusChargeRequest)
        };

        fetch(`api/Location/UpdateLocationStatusAndCharge`, requestOptions)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText, chargeUpdateCompleted: true });
                    return;
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "Location charge confirmed",chargeUpdateCompleted: true });
                            return;
                        }
                        else {
                            this.setState({ alertMessage: apiResponse.errorMessage, chargeUpdateCompleted: true });
                            return;
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to update Location Status and Charge!!", chargeUpdateCompleted: true });
                       
                        return;
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, chargeUpdateCompleted: true });
            });
    }
    render() {
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered>
                    <Modal.Header>
                        <Modal.Title>Please confirm Location charge</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {alertMessage}
                        <Container>
                            <Row className="mb-3">
                                <Col xs={4}>Location : </Col>
                                <Col xs={8}>
                                    <label>{this.state.selectedLocationText}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={4}>Status : </Col>
                                <Col xs={8}>
                                    <label>{this.state.selectedStatus}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={4}>Current Charge : </Col>
                                <Col xs={8}>
                                    <label>{this.state.selectedChargeType}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={4}>Charge : </Col>
                                <Col xs={8}>
                                    <select className="form-select form-control" aria-label=".form-select-lg example" value={this.state.selectedChargeTypeId} 
                                        onChange={(e) => {
                                            this.setState({ selectedChargeTypeId: e.target.value });
                                        }} disabled={this.state.chargeUpdateCompleted} >
                                        {this.state.chargeTypes.map(row =>
                                            <option key={row.id} value={row.id}>{row.desc}</option>
                                        )}
                                    </select>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-success col-12 mb-2"  style={{ display: this.state.chargeUpdateCompleted === false ? 'block' : 'none' }} onClick={() => this.validateLocationStatus()}>
                            Confirm
                        </Button>
                        <Button className="btn btn-success col-12 mb-2" style={{ display: this.state.chargeUpdateCompleted === true ? 'block' : 'none' }} onClick={this.props.onClickClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ConfirmLocationChargeSkeleton;